var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_5315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5229 20 20 15.5229 20 10C20 4.47716 15.5229 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5229 4.47716 20 10 20Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99997C20 15.5 15.5 20 10 20C6.81253 20 4.00002 18.5625 2.1875 16.25C3.875 17.625 6.06251 18.4375 8.43749 18.4375C13.9375 18.4375 18.4375 13.9375 18.4375 8.43749C18.4375 6.06251 17.625 3.875 16.25 2.1875C18.5625 3.99994 20 6.81244 20 9.99997Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 7.12472L8.93747 14.2498C8.49995 14.7498 7.74998 14.7498 7.31246 14.2498L4.56245 11.1872C4.18747 10.7497 4.18747 10.0622 4.62494 9.62473C5.06246 9.24974 5.74994 9.24974 6.18746 9.68722L8.12497 11.8747L13.8125 5.68722C14.25 5.2497 14.9375 5.18721 15.375 5.62473C15.8125 5.99972 15.8125 6.74973 15.4375 7.12472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_5315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.1dc45d7e51ef8928d99b0cd2fbd32814.svg";
export { ForwardRef as ReactComponent };